import { getSiteTextFallbackContent } from "@Front/Stores/defaultSiteTextFallbacks";

function fallbackTrimToMap(value: string, textKey: string, locale: string): string {
	if (typeof value === "string" && value.trim().length > 0) {
		return value;
	}
	return getSiteTextFallbackContent(textKey, locale) ?? "";
}

export type StepEmailSiteTextsDisplay = {
	welcomeTitleDisplay: string;
	welcomeSubtitleDisplay: string;
	notarySectionTitleDisplay: string;
	notaryCtaDisplay: string;
	notarySubscribeCtaDisplay: string;
	clientsSectionTitleDisplay: string;
	emailPlaceholderDisplay: string;
	submitCtaDisplay: string;
};

type RawSiteTextFields = {
	locale: string;
	welcomeTitle: string;
	welcomeSubtitle: string;
	notarySectionTitle: string;
	notaryCta: string;
	notarySubscribeCta: string;
	clientsSectionTitle: string;
	emailPlaceholder: string;
	submitCta: string;
};

export function buildStepEmailSiteTextsDisplay(raw: RawSiteTextFields): StepEmailSiteTextsDisplay {
	const { locale } = raw;
	return {
		welcomeTitleDisplay: fallbackTrimToMap(raw.welcomeTitle, "login.header.title", locale),
		welcomeSubtitleDisplay: fallbackTrimToMap(raw.welcomeSubtitle, "login.header.subtitle", locale),
		notarySectionTitleDisplay: fallbackTrimToMap(raw.notarySectionTitle, "login.section.notaries.title", locale),
		notaryCtaDisplay: fallbackTrimToMap(raw.notaryCta, "login.section.notaries.cta", locale),
		notarySubscribeCtaDisplay: fallbackTrimToMap(
			raw.notarySubscribeCta,
			"login.section.notaries.subscribeCta",
			locale,
		),
		clientsSectionTitleDisplay: fallbackTrimToMap(raw.clientsSectionTitle, "login.section.clients.title", locale),
		emailPlaceholderDisplay: fallbackTrimToMap(raw.emailPlaceholder, "login.form.email.placeholder", locale),
		submitCtaDisplay: fallbackTrimToMap(raw.submitCta, "login.form.submit", locale),
	};
}
